const map = {
	"./4c.png": 232,
	"./a121.png": 922,
	"./acaboom.png": 267,
	"./acesss.png": 721,
	"./amplified.png": 84,
	"./avensure.png": 40,
	"./collectionpot.png": 178,
	"./foundationpartners.png": 377,
	"./gifted.png": 594,
	"./ima.png": 452,
	"./jbm.png": 110,
	"./kerfuffle.png": 63,
	"./kolekti.png": 572,
	"./lifestyle.png": 402,
	"./mintsoft.png": 647,
	"./motivates.png": 77,
	"./moxiworks.png": 834,
	"./orderly.png": 666,
	"./rac.png": 801,
	"./salesforce.png": 14,
	"./smithsnews.png": 642,
	"./tuffnells.png": 978,
	"./unleashed.png": 100,
	"./wiin.png": 22
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 849;